export default __webpack_public_path__ + "static/media/4726.cde89c5a.png";